import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  list: {},
  scrollIndex: 0,
};

export const productList = createSlice({
  name: 'productList',
  initialState,
  reducers: {
    setList: (state, action) => ({
      ...state,
      list: action.payload
    }),
    setScrollIndex: (state, action) => ({
      ...state,
      scrollIndex: action.payload
    }),
  },
  effects: () => ({}),
});

export const { setList, setScrollIndex } = productList.actions;
export const selectList = (state) => state.productList.list;

export default productList.reducer;